export const PAGE_HEADING_ID = 'page-heading';
export const MORE_DETAILS_DIALOG_TITLE_ID = 'more-details-dialog-title';
export const VOICE_ERROR_DETAILS_TITLE_ID = 'voice-error-details-title';
export const NO_ACCOUNT_RADIO_GROUP_LABEL_ID = 'no-account-radio-group-label';
